import { render, staticRenderFns } from "./PlpListViewContainer.vue?vue&type=template&id=94c5e13c&"
import script from "./PlpListViewContainer.vue?vue&type=script&lang=js&"
export * from "./PlpListViewContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports